<div
  class="chart"
  data-cy="dashboard-location-preferences.chart">
  <coa-sankey-diagram
    [data]="clientLocationPreferences?.locationPreferences | sankey"
    [label]="clientLocationPreferences?.location.name">
  </coa-sankey-diagram>
</div>
